import React from 'react'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { map, includes, toLower } from 'lodash'
import { search, users, api } from '../redux'

import UserDisplay from '../components/UserDisplay'

const UserSearchBox = ({ dispatch, searchOptions, input }) => (
    <Select
        options={ searchOptions }
        onInputChange={ (input) => dispatch(search.perform({
            query    : input,
            keys     : ['email', 'phone'],
            url      : api.buildURL('users'),
            selector : users.getAll
        })) }
        optionRenderer={ (user) => <UserDisplay user={ user } /> }
        onChange={ (value) => input.onChange(value) }
        value={ input.value }
    />
)

function mapStateToProps(state) {
    const searchResults = search.getResults(api.buildURL('users'))(state)
    const query = toLower(search.getQuery(api.buildURL('users'))(state))
    const searchOptions = map(
        searchResults,
        (user) => {
            const label = includes(toLower(user.email), query) ? user.email : user.phone
            return { label, ...user }
        }
    )
    return { searchOptions }
}

UserSearchBox.propTypes = {
    dispatch      : PropTypes.func.isRequired,
    searchOptions : PropTypes.arrayOf(PropTypes.object),
    input         : PropTypes.object
}

export default connect(mapStateToProps)(UserSearchBox)
